<script setup lang="ts">
  import { computed } from 'vue';
  import type { TrainingDetail } from '@/entities/Training';
  import { TRAINING_EMPTY_VALUE } from '../../lib/trainingEmptyValue';
  import { formatTrainingDocumentRevisionLabel } from '../../lib/formatTrainingDocumentRevisionLabel';

  const props = defineProps<{
    document?: TrainingDetail['documents'][number] | null;
  }>();

  const prefixLabel = computed(() => props.document?.prefix ?? TRAINING_EMPTY_VALUE);

  const titleLabel = computed(() => props.document?.title ?? TRAINING_EMPTY_VALUE);

  const revisionLabel = computed(() =>
    props.document
      ? formatTrainingDocumentRevisionLabel(props.document.revision)
      : TRAINING_EMPTY_VALUE
  );
</script>

<template>
  <section
    data-testid="view-training-section-document"
    class="flex flex-col gap-4 border-b border-gray-02 px-6 py-8"
  >
    <h2 class="text-sm font-semibold text-gray-07">
      Documento SGQ:
    </h2>
    <div class="flex flex-wrap gap-4">
      <div class="flex w-full flex-col gap-2 md:w-fit">
        <span class="text-xs font-semibold text-gray-07">Prefixo</span>
        <span
          data-testid="view-training-document-prefix"
          class="rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-sm whitespace-nowrap text-gray-07 md:min-w-[81px]"
        >
          {{ prefixLabel }}
        </span>
      </div>
      <div class="flex w-full flex-col gap-2 md:w-[338px]">
        <span class="text-xs font-semibold text-gray-07">Título</span>
        <span
          data-testid="view-training-document-title"
          class="rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-sm text-gray-07"
        >
          {{ titleLabel }}
        </span>
      </div>
      <div class="flex w-full flex-col gap-2 md:w-fit">
        <span class="text-xs font-semibold text-gray-07">Revisão</span>
        <span
          data-testid="view-training-document-revision"
          class="rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-sm whitespace-nowrap text-gray-07 md:min-w-[84px]"
        >
          {{ revisionLabel }}
        </span>
      </div>
    </div>
  </section>
</template>
